import * as React from "react";
import type { SVGProps } from "react";
const SvgSlackLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={264}
    height={264}
    fill="none"
    viewBox="0 0 264 264" {...props}
  >
    <path fill="#4B144A" d="M0 0h264v264H0z" />
    <g
      fillRule="evenodd"
      clipPath="url(#slack-logo-icon_svg__a)"
      clipRule="evenodd"
    >
      <path
        fill="#36C5F0"
        d="M111.025 52c-8.749.007-15.829 7.125-15.822 15.897-.007 8.771 7.08 15.89 15.828 15.896h15.829v-15.89c.006-8.772-7.08-15.89-15.835-15.903q.009 0 0 0m0 42.4H68.828c-8.748.006-15.835 7.125-15.829 15.897-.012 8.771 7.074 15.89 15.823 15.903h42.203c8.748-.006 15.835-7.125 15.829-15.897.006-8.778-7.081-15.897-15.829-15.903"
      />
      <path
        fill="#2EB67D"
        d="M211.26 110.297c.007-8.772-7.08-15.89-15.828-15.897-8.749.006-15.835 7.125-15.829 15.897V126.2h15.829c8.748-.006 15.835-7.125 15.828-15.903m-42.203 0v-42.4c.007-8.766-7.074-15.884-15.822-15.897-8.749.007-15.835 7.125-15.829 15.897v42.4c-.013 8.771 7.074 15.89 15.822 15.903 8.749-.006 15.836-7.125 15.829-15.903"
      />
      <path
        fill="#ECB22E"
        d="M153.229 211c8.748-.007 15.835-7.125 15.828-15.897.007-8.772-7.08-15.89-15.828-15.897H137.4v15.897c-.007 8.765 7.08 15.884 15.829 15.897m0-42.407h42.203c8.748-.006 15.835-7.125 15.828-15.896.013-8.772-7.073-15.891-15.822-15.904h-42.203c-8.748.007-15.835 7.125-15.829 15.897-.006 8.778 7.074 15.897 15.823 15.903"
      />
      <path
        fill="#E01E5A"
        d="M53 152.697c-.007 8.772 7.08 15.89 15.829 15.897 8.748-.007 15.835-7.125 15.828-15.897V136.8H68.83c-8.749.007-15.835 7.125-15.829 15.897m42.203 0v42.4c-.013 8.772 7.074 15.89 15.822 15.903 8.749-.006 15.835-7.125 15.829-15.897V152.71c.013-8.772-7.074-15.891-15.822-15.903-8.755 0-15.835 7.118-15.829 15.89"
      />
    </g>
    <defs>
      <clipPath id="slack-logo-icon_svg__a">
        <path fill="#fff" d="M53 52h158.26v159H53z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSlackLogoIcon;
